import { SerpTabId, SerpTabItem } from './SerpTabs.types';

export const MAX_DISPLAYED_TAB_COUNT = 100;

export const formatTabCount = (count: number): string =>
  count > MAX_DISPLAYED_TAB_COUNT ? `${MAX_DISPLAYED_TAB_COUNT}+` : String(count);

export const getSerpTabElementId = (panelId: string, tabId: SerpTabId) => `${panelId}-tab-${tabId}`;

export const getVisibleTabs = (tabs: SerpTabItem[], activeTab: SerpTabId) =>
  tabs.filter((tab) => tab.id === 'places' || tab.id === activeTab || (tab.count ?? 0) > 0);

export const getNextTabIndex = (key: string, currentIndex: number, length: number): number | null => {
  switch (key) {
    case 'ArrowRight':
      return (currentIndex + 1) % length;
    case 'ArrowLeft':
      return (currentIndex - 1 + length) % length;
    case 'Home':
      return 0;
    case 'End':
      return length - 1;
    default:
      return null;
  }
};
